export default __webpack_public_path__ + "static/media/HondaFavicon.c99203db.ico";